import { useEffect } from 'react';
import { Box, Flex, PrimaryPaper } from '@atoms/layout';
import { useRefreshSyncStore } from '@libs/store/refreshSync';
import { ShiftTypePresetsFilters } from './filters';
import { ShiftTypePresetsTableMenu } from './menu';
import { ShiftTypePresetsTable } from './table/table';
import {
  useShiftTypePresetDrawerStore,
  useShiftTypePresetsFiltersStore,
  useShiftTypePresetsList,
} from '@libs/store/shiftTypePresets';
import { EditShiftTypePresetDrawer } from './drawers';
import { ShiftTypePresetListItem } from '@libs/models/shiftTemplates';
import { useLocationStore } from '@libs/store/locations';

export function ShiftsTypePresetsListPage() {
  const { refreshTrigger, callRefresh } = useRefreshSyncStore();
  const { currentLocationID, loadSimple } = useLocationStore();
  const { initialized: listInitialized, load, list } = useShiftTypePresetsList();
  const { openDrawer } = useShiftTypePresetDrawerStore();
  const { activeFilters, getFilter, hasFilter, setFilter } = useShiftTypePresetsFiltersStore();

  const loading = !listInitialized;

  const localizationSubset = 'templates.shiftTypePresets.listPage';

  useEffect(() => {
    callRefresh();
  }, [callRefresh]);

  useEffect(() => {
    if (!currentLocationID) {
      loadSimple();
    }
  }, [currentLocationID]);

  useEffect(() => {
    if (!currentLocationID) {
      return;
    }
    if (!hasFilter('location') || !(getFilter('location')?.value as string[]).includes(currentLocationID)) {
      setFilter({ key: 'location', value: [currentLocationID] });
    }
  }, [currentLocationID, activeFilters]);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    load(activeFilters);
  }, [load, refreshTrigger, activeFilters]);

  const handleRowClick = (row: ShiftTypePresetListItem) => {
    openDrawer(row.id, row);
  };

  return (
    <>
      <ShiftTypePresetsTableMenu loading={loading} localizationSubset={localizationSubset} />
      <PrimaryPaper sx={{ height: '100%', minHeight: 0, mt: 2 }}>
        <Flex column height="100%">
          <ShiftTypePresetsFilters loading={loading} localizationSubset={localizationSubset} />
          <Box mt={2} height="100%" minHeight={0}>
            <ShiftTypePresetsTable
              loading={loading}
              rows={list}
              localizationSubset={localizationSubset}
              onRowClick={handleRowClick}
            />
          </Box>
        </Flex>
      </PrimaryPaper>
      <Drawers />
    </>
  );
}

function Drawers() {
  const { callRefresh } = useRefreshSyncStore();

  return (
    <>
      <EditShiftTypePresetDrawer onSaveCall={callRefresh} />
    </>
  );
}
